import l, { useRef as P } from "react";
import { useUniqueId as B } from "../../hooks/useUniqueId.js";
import { modalDefaultProps as r } from "./props.js";
import { cls as p } from "../../helpers/cls.js";
import { useClickOutside as D } from "./hooks/useClickOutside.js";
import { useNavigation as I } from "./hooks/useNavigation.js";
import { useOnAfterOpen as R } from "./hooks/useOnAfterOpen.js";
import { useScrollLock as j } from "./hooks/useScrollLock.js";
import { sizeModal as A } from "./hooks/sizeModal.js";
import { Close as W } from "./components/Close/index.js";
import { TopBar as H } from "./components/TopBar/index.js";
import { BottomBar as M } from "./components/BottomBar/index.js";
import { Portal as z } from "./components/Portal/index.js";
var L = Object.defineProperty,
  T = Object.defineProperties,
  V = Object.getOwnPropertyDescriptors,
  s = Object.getOwnPropertySymbols,
  _ = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  u = (e, o, a) => o in e ? L(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[o] = a,
  v = (e, o) => {
    for (var a in o || (o = {})) _.call(o, a) && u(e, a, o[a]);
    if (s) for (var a of s(o)) b.call(o, a) && u(e, a, o[a]);
    return e;
  },
  $ = (e, o) => T(e, V(o)),
  U = (e, o) => {
    var a = {};
    for (var t in e) _.call(e, t) && o.indexOf(t) < 0 && (a[t] = e[t]);
    if (e != null && s) for (var t of s(e)) o.indexOf(t) < 0 && b.call(e, t) && (a[t] = e[t]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const q = e => {
  var o = e,
    {
      children: a,
      open: t = r.open,
      preventCloseOnOutsideClick: x = r.preventCloseOnOutsideClick,
      maxHeight: h = r.maxHeight,
      maxWidth: C = r.maxWidth,
      closeable: E = r.closeable,
      variant: i = r.variant,
      testId: F,
      size: f,
      closeCallback: m,
      onAfterOpen: w,
      title: g,
      className: y,
      bottomBar: c,
      id: k,
      portalTo: N
    } = o,
    S = U(o, ["children", "open", "preventCloseOnOutsideClick", "maxHeight", "maxWidth", "closeable", "variant", "testId", "size", "closeCallback", "onAfterOpen", "title", "className", "bottomBar", "id", "portalTo"]);
  const d = P(null),
    O = B("ds-modal-body"),
    n = i === "filter" || i === "side-sheet";
  return I({
    closeCallback: m,
    open: t,
    modalRef: d
  }), D({
    closeCallback: m,
    open: t,
    modalRef: d,
    preventCloseOnOutsideClick: x
  }), R({
    open: t,
    onAfterOpen: w
  }), j({
    open: t
  }), l.createElement(z, {
    to: N
  }, l.createElement("div", $(v({
    "data-ds-component": "DS-Modal",
    "aria-hidden": !t
  }, S), {
    className: p("olx-modal", "olx-modal--".concat(i), y),
    "data-show": t
  }), l.createElement("div", {
    id: k,
    ref: d,
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": O,
    "data-show": t,
    className: p("olx-modal__dialog", "olx-modal__dialog--".concat(i), t && "olx-modal__dialog--show"),
    style: v({
      "--modal-max-height": h
    }, !n && {
      "--modal-max-width": f ? A(f) : C
    })
  }, E && !n && l.createElement(W, {
    closeCallback: m
  }), n && l.createElement(H, {
    title: g,
    closeCallback: m
  }), l.createElement("div", {
    className: p("olx-modal__content", "olx-modal__content--".concat(i), n && c && "olx-modal__content--side-sheet--bottombar"),
    id: O
  }, a, n && c && l.createElement(M, null, c)))));
};
export { q as Modal };